import React from "react";
import { Instagram, Linkedin, Pin, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
function FooterCollectionsMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-24 bg-muted/20 animate-pulse rounded-sm" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li>
          <Link to="/TheVaultPage" className="text-muted-foreground hover:text-primary transition-colors text-sm">
            The Vault
          </Link>
        </li>
        <li>
          <Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors text-sm">
            New Arrivals
          </Link>
        </li>
        <li>
          <Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors text-sm">
            Furniture
          </Link>
        </li>
        <li>
          <Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors text-sm">
            Fine Art
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function HeritageFooter() {
  return <footer id="heritage-footer" className="dark bg-background text-foreground py-16 border-t border-border/10">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {}
          <div className="flex flex-col items-start">
            <div className="flex items-center gap-3 mb-6">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569214/img/image_yywata7m.png" alt="NOBILITIES ANTIQUES GENERAL TRADING - L.L.C." className="h-7 w-auto object-contain" />
              <span className="font-serif text-sm font-bold tracking-tight">
                NOBILITIES ANTIQUES GENERAL TRADING - L.L.C.
              </span>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              Preserving history through a curated collection of 18th-century elegance and rare artifacts. 
              Nobilities Antiques brings the finest provenance to the modern collector.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-serif text-lg font-semibold mb-6 text-foreground">The Collections</h3>
            <MenuProvider menu_id="23" className="w-full">
              <FooterCollectionsMenu />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-serif text-lg font-semibold mb-6 text-foreground">Client Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/faq" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Shipping & Delivery
                </Link>
              </li>
              <li>
                <Link to="/returns" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Returns & Exchanges
                </Link>
              </li>
              <li>
                <Link to="/appraisals" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Appraisal Services
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-serif text-lg font-semibold mb-6 text-foreground">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <span>Office No: 08, Al Sqor Althalatha General Contracting &amp; Maintenance Building, M16, Mussafah Industrial Area, Abu Dhabi, UAE.&nbsp;</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Phone className="w-5 h-5 text-primary shrink-0" />
                <span>+971 54 779 1923</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Mail className="w-5 h-5 text-primary shrink-0" />
                <Link to="mailto:contact@nobilitiesantiques.com" className="hover:text-primary transition-colors">nobilitiesantiques@gmail.com</Link>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="bg-white/10 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-xs text-muted-foreground text-center md:text-left">
            &copy; {new Date().getFullYear()} NOBILITIES ANTIQUES GENERAL TRADING - L.L.C. All rights reserved.
          </p>
          
          <div className="flex items-center gap-6">
            <Link to="https://instagram.com" newTab className="text-foreground hover:text-primary transition-colors">
              <Instagram className="w-5 h-5" />
              <span className="sr-only">Instagram</span>
            </Link>
            <Link to="https://pinterest.com" newTab className="text-foreground hover:text-primary transition-colors">
              <Pin className="w-5 h-5" />
              <span className="sr-only">Pin</span>
            </Link>
            <Link to="https://linkedin.com" newTab className="text-foreground hover:text-primary transition-colors">
              <Linkedin className="w-5 h-5" />
              <span className="sr-only">LinkedIn</span>
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}